const throttle = {}

throttle.install = (Vue) => {
    Vue.directive('throttle', {
        inserted: function (el, binding) {
            const [fn, event, time] = binding.value
            let timer
            el.addEventListener(event, () => {
                if (timer) return // 冷却期内忽略点击

                fn() // 立即执行

                timer = setTimeout(() => {
                    timer = null // 冷却期结束
                }, time)
            })
        }
    })
}

export default throttle
